module.exports = __webpack_public_path__ + "static/background-2-4d4f499e9752ad5f06000313cfb8075e.png";